import { useEffect, useState } from "react";
import kiemTienIcon from "../assets/kiem-tien.gif";
import { absUrl, useSiteOrigin } from "../useSiteOrigin";
import { useSettings } from "../useSettings";
import "./footer.css";

function IconBangKeo() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" aria-hidden="true">
      <g clipPath="url(#kbv-ft-bangkeo)">
        <circle cx="9.31" cy="9.31" r="1.55" fill="#B8ADAF" />
        <path d="M9.31 9.31L17.07 1.55M13.97 9.31C13.97 11.88 11.88 13.97 9.31 13.97C6.74 13.97 4.65 11.88 4.65 9.31C4.65 6.74 6.74 4.65 9.31 4.65C11.88 4.65 13.97 6.74 13.97 9.31ZM17.07 9.31C17.07 13.59 13.59 17.07 9.31 17.07C5.03 17.07 1.55 13.59 1.55 9.31C1.55 5.03 5.03 1.55 9.31 1.55C13.59 1.55 17.07 5.03 17.07 9.31Z" stroke="#B8ADAF" strokeWidth="1.3" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="kbv-ft-bangkeo">
          <rect width="18.62" height="18.62" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

function IconTiLe() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M17 1.3C18.49 1.3 19.7 2.51 19.7 4V16C19.7 17.49 18.49 18.7 17 18.7H3C1.51 18.7.3 17.49.3 16V4C.3 2.51 1.51 1.3 3 1.3H17ZM3 2.7C2.28 2.7 1.7 3.28 1.7 4V16C1.7 16.72 2.28 17.3 3 17.3H17C17.72 17.3 18.3 16.72 18.3 16V4C18.3 3.28 17.72 2.7 17 2.7H3ZM7.43 6.5C7.77 6.5 8.05 6.78 8.05 7.13V10C8.05 10.35 7.77 10.63 7.43 10.63H5.24V12.23H7.43C7.77 12.23 8.05 12.52 8.05 12.87C8.05 13.22 7.77 13.5 7.43 13.5H4.62C4.28 13.5 4 13.22 4 12.87V10C4 9.65 4.28 9.37 4.62 9.37H6.81V7.77H4.62C4.28 7.77 4 7.48 4 7.13C4 6.78 4.28 6.5 4.62 6.5H7.43ZM15.38 6.5C15.72 6.5 16 6.78 16 7.13V12.87C16 13.22 15.72 13.5 15.38 13.5C15.04 13.5 14.76 13.22 14.76 12.87V10.63H12.57C12.23 10.63 11.95 10.35 11.95 10V7.13C11.95 6.78 12.23 6.5 12.57 6.5C12.92 6.5 13.19 6.78 13.19 7.13V9.37H14.76V7.13C14.76 6.78 15.04 6.5 15.38 6.5ZM10.1 11.86C10.53 11.86 10.89 12.21 10.89 12.65V12.69C10.89 13.13 10.53 13.48 10.1 13.48C9.66 13.48 9.3 13.13 9.3 12.69V12.65C9.3 12.21 9.66 11.86 10.1 11.86Z" fill="#656565" />
    </svg>
  );
}

function IconNhanDinh() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" aria-hidden="true">
      <path d="M12.41 1.55V3.88M6.21 1.55V3.88" stroke="#B8ADAF" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M2.33 6.17C2.33 4.26 3.88 2.71 5.78 2.71H12.83C14.74 2.71 16.29 4.26 16.29 6.17V13.61C16.29 15.52 14.74 17.06 12.83 17.06H5.78C3.88 17.06 2.33 15.52 2.33 13.61V6.17Z" stroke="#B8ADAF" strokeWidth="1.3" />
      <path d="M2.33 6.98H16.29" stroke="#B8ADAF" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M9.55 14.22C9.49 14.19 9.42 14.19 9.37 14.22L7.7 15.08C7.55 15.15 7.37 15.02 7.41 14.86L7.77 13.18C7.79 13.11 7.76 13.03 7.71 12.98L6.35 11.83C6.22 11.72 6.29 11.5 6.46 11.48L8.32 11.28C8.39 11.27 8.45 11.23 8.48 11.17L9.28 9.58C9.35 9.43 9.56 9.43 9.64 9.58L10.43 11.17C10.47 11.23 10.52 11.27 10.59 11.28L12.45 11.48C12.63 11.5 12.7 11.72 12.56 11.83L11.21 12.98C11.15 13.03 11.13 13.11 11.14 13.18L11.51 14.86C11.54 15.02 11.37 15.15 11.22 15.08L9.55 14.22Z" stroke="#B8ADAF" />
    </svg>
  );
}

function IconUser() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" aria-hidden="true">
      <path d="M8.92 10.6C5.79 10.6 3.16 12.71 2.38 15.59C2.11 16.56 2.95 17.38 3.95 17.38H13.9C14.9 17.38 15.73 16.56 15.47 15.59C14.68 12.71 12.05 10.6 8.92 10.6Z" stroke="#B8ADAF" strokeWidth="1.21" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.09 4.72C12.09 6.47 10.67 7.88 8.92 7.88C7.17 7.88 5.76 6.47 5.76 4.72C5.76 2.97 7.17 1.55 8.92 1.55C10.67 1.55 12.09 2.97 12.09 4.72Z" stroke="#B8ADAF" strokeWidth="1.21" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const MENU = [
  { id: "bangkeo", label: "Bảng kèo", href: "/", icon: "bangkeo" },
  { id: "basket", label: "Bóng rổ", href: "/?sport=basketball", emoji: "🏀", sport: "basketball" },
  { id: "tile", label: "Tỉ lệ kèo", href: "/ti-le-keo", icon: "tile" },
  { id: "kiemtien", label: "Kiếm Tiền", href: "/kiem-tien", gif: kiemTienIcon, preserveColor: true },
  { id: "nhandinh", label: "Nhận định", href: "/nhan-dinh", icon: "nhandinh" },
  { id: "user", label: "User", href: "/thong-tin-ca-nhan", icon: "user" },
];

const ICONS = {
  bangkeo: IconBangKeo,
  tile: IconTiLe,
  nhandinh: IconNhanDinh,
  user: IconUser,
};

function isItemActive(origin, item, hereHref) {
  let here;
  let target;
  try {
    here = new URL(hereHref);
    target = new URL(absUrl(origin, item.href));
  } catch {
    return false;
  }
  if (here.origin !== target.origin) return false;
  const sport = here.searchParams.get("sport");
  if (item.sport === "basketball") {
    return (here.pathname === "/" && sport === "basketball") || here.pathname.startsWith("/bong-ro");
  }
  if (item.href === "/") return here.pathname === "/" && sport !== "basketball";
  return here.pathname === target.pathname || here.pathname.startsWith(`${target.pathname}/`);
}

function MenuIcon({ item, active }) {
  if (item.emoji) {
    return (
      <span className="kbv-footer__icon is-emoji" aria-hidden="true">
        {item.emoji}
      </span>
    );
  }
  if (item.gif) {
    return (
      <span className="kbv-footer__icon is-color">
        <img src={item.gif} alt="" width="36" height="36" draggable="false" />
      </span>
    );
  }
  const Icon = ICONS[item.icon];
  return (
    <span className={`kbv-footer__icon${active ? " is-active" : " is-inactive"}`}>
      {Icon ? <Icon /> : null}
    </span>
  );
}

function Social({ href, label, children }) {
  return (
    <a className="kbv-footer__social" href={href} target="_blank" rel="noreferrer" aria-label={label}>
      {children}
    </a>
  );
}

export default function Footer() {
  const origin = useSiteOrigin();
  const { settings } = useSettings();
  const [visible, setVisible] = useState(true);
  const [path, setPath] = useState(() =>
    typeof window === "undefined" ? "" : window.location.pathname + window.location.search
  );
  const logo = settings?.keo_bong_vip_logo_link || "";
  const domain = settings?.domain_site || "keobongvip.top";
  const domainHref = /^https?:\/\//i.test(domain) ? domain : `https://${domain}`;
  const domainLabel = String(domain).replace(/^https?:\/\//i, "").replace(/\/$/, "");

  useEffect(() => {
    let lastY = window.scrollY;
    let first = true;
    const onScroll = () => {
      const y = window.scrollY;
      if (first) {
        first = false;
        lastY = y;
        return;
      }
      if (y < lastY) setVisible(true);
      else if (y > lastY && y > 100) setVisible(false);
      lastY = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const sync = () => setPath(window.location.pathname + window.location.search);
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  return (
    <div className="kbv-home kbv-footer">
      <footer className={`kbv-footer__mobile${visible ? "" : " is-hidden"}`} data-mobile-footer>
        <nav className="kbv-footer__nav" aria-label="Điều hướng chính">
          {MENU.map((item) => {
            const active = isItemActive(origin, item, window.location.origin + path);
            return (
              <a
                key={item.id}
                className={`kbv-footer__item${active ? " is-active" : ""}`}
                href={absUrl(origin, item.href)}
                aria-current={active ? "page" : undefined}
              >
                <MenuIcon item={item} active={active} />
                <span className="kbv-footer__label">{item.label}</span>
                <span className="kbv-footer__dot-wrap" aria-hidden="true">
                  <span className="kbv-footer__dot" />
                </span>
              </a>
            );
          })}
        </nav>
      </footer>

      <footer className="kbv-footer__desktop">
        <div className="kbv-footer__desktop-inner">
          <div className="kbv-footer__links">
            <a href={absUrl(origin, "/sitemap.xml")}>Sitemap</a>
            <a href={absUrl(origin, "/dieu-khoan")}>Điều khoản</a>
            <a href={absUrl(origin, "/chinh-sach-bao-mat")}>Chính sách bảo mật</a>
            <a href={absUrl(origin, "/cookies")}>Cookies</a>
            <a href="mailto:keobongvip.info@gmail.com">Góp ý</a>
          </div>
          <div className="kbv-footer__cols">
            <div className="kbv-footer__col">
              {logo ? (
                <a className="kbv-footer__logo" href={origin}>
                  <img src={logo} alt="logo" />
                </a>
              ) : null}
            </div>
            <div className="kbv-footer__col kbv-footer__col--contact">
              <div className="kbv-footer__contact-title">Liên hệ với Keobongvip</div>
              <div className="kbv-footer__contact-row">
                <span>Địa chỉ: 34 Đường số 4, Phường 11, Gò Vấp, Hồ Chí Minh 700000</span>
                <span className="kbv-footer__sep" aria-hidden="true">|</span>
                <span>
                  SĐT: <a href="#">0896910134</a>
                </span>
                <span className="kbv-footer__sep" aria-hidden="true">|</span>
                <span>
                  Email: <a href="mailto:keobongvip.info@gmail.com">keobongvip.info@gmail.com</a>
                </span>
                <span className="kbv-footer__sep" aria-hidden="true">|</span>
                <span>
                  Website:{" "}
                  <a href={domainHref} target="_blank" rel="noreferrer">
                    {domainLabel}
                  </a>
                </span>
              </div>
            </div>
            <div className="kbv-footer__col">
              <div className="kbv-footer__social-title">Theo dõi ngay KeoBongVip</div>
              <div className="kbv-footer__social-sub">Nhận sớm nhất các tin tức mới bật</div>
              <div className="kbv-footer__socials">
                <Social href="https://www.facebook.com/keobongvipinfo/" label="Facebook">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M13.5 22v-8h2.7l.4-3H13.5V9.1c0-.9.3-1.6 1.7-1.6H16.8V4.8c-.3 0-1.4-.1-2.7-.1-2.7 0-4.6 1.6-4.6 4.6V11H7v3h2.5v8h4z" />
                  </svg>
                </Social>
                <Social href="https://www.youtube.com/@keobongvipinfo" label="YouTube">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M21.6 7.2a2.8 2.8 0 0 0-2-2C17.9 4.8 12 4.8 12 4.8s-5.9 0-7.6.4a2.8 2.8 0 0 0-2 2A29.1 29.1 0 0 0 2 12a29.1 29.1 0 0 0 .4 4.8 2.8 2.8 0 0 0 2 2c1.7.4 7.6.4 7.6.4s5.9 0 7.6-.4a2.8 2.8 0 0 0 2-2A29.1 29.1 0 0 0 22 12a29.1 29.1 0 0 0-.4-4.8zM10 15.5v-7l6 3.5-6 3.5z" />
                  </svg>
                </Social>
                <Social href="https://www.tiktok.com/@keobongvipvai" label="TikTok">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M16 3c.4 2.3 2 4.1 4 4.6V11c-1.8-.1-3.4-.8-4-1.3v6.4c0 3.1-2.5 5.6-5.6 5.6A5.6 5.6 0 0 1 4.8 16c0-3.1 2.5-5.6 5.6-5.6.4 0 .8 0 1.2.1V13a2.7 2.7 0 0 0-1.2-.3A3.3 3.3 0 1 0 13.7 16V3H16z" />
                  </svg>
                </Social>
                <Social href="https://t.me/kbvoffcial" label="Telegram">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M21.5 3.5 2.9 10.7c-1.3.5-1.3 1.2-.2 1.6l4.8 1.5 1.9 6c.2.6.1.8.8.8.5 0 .8-.2 1.1-.5l2.3-2.2 4.8 3.5c.9.5 1.5.2 1.7-.8l3.2-15.2c.3-1.2-.4-1.7-1.8-1.1ZM8.2 13.4l10.8-6.8c.5-.3.9-.1.5.3l-8.9 8-1.2 3.6-1.2-5.1Z" />
                  </svg>
                </Social>
              </div>
            </div>
          </div>
          <p className="kbv-footer__blurb">
            Keobongvip chuyên cung cấp tỷ lệ kèo nhà cái chuẩn xác hàng đầu thị trường. Với các tỷ lệ kèo thịnh hành như: Kèo Châu Á, Kèo Châu Âu, Kèo Tài Xỉu, Kèo Phạt Góc
          </p>
          <p className="kbv-footer__copy">© 2024-2025. Toàn bộ bản quyền thuộc Keobongvip</p>
        </div>
      </footer>
    </div>
  );
}
